export default __webpack_public_path__ + "static/media/ReportsIcon.d814f7ee.svg";